// The count->colour scale shared by ServiceCountyMap.js and the Dashboard's
// Service Counties card, so the two maps never shade the same count
// differently. The approved-county list that used to live here moved to the
// database on 2026-10-20 — see lib/serviceArea.js.

// Sequential single-hue (copper) scale, light -> dark, for map fill by count.
export function colorForCount(v, max) {
  if (v <= 0) return 'var(--bg3)';
  const t = Math.min(1, v / Math.max(1, max));
  const stops = [[232, 184, 150], [199, 123, 84], [138, 74, 44]];
  const scaled = t * (stops.length - 1);
  const i = Math.min(stops.length - 2, Math.floor(scaled));
  const f = scaled - i;
  const mix = (k) => Math.round(stops[i][k] + (stops[i + 1][k] - stops[i][k]) * f);
  return `rgb(${mix(0)},${mix(1)},${mix(2)})`;
}
